import React from "react";
import { Link } from "react-router-dom";
import { Loading } from "../Common/OtherElements/Loading";

const initials = (name) => {
  const parts = (name || "").trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  return parts
    .slice(0, 2)
    .map((part) => part[0].toUpperCase())
    .join("");
};

const formatAddedOn = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  return date.toLocaleDateString(undefined, {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const formatExperience = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const years = Number(value);
  if (Number.isNaN(years)) return null;
  return `${years} ${years === 1 ? "year" : "years"}`;
};

const ActivityList = ({ items, emptyText, tone, showExperience }) => {
  if (!items.length) {
    return <p className="text-muted mb-0 py-3">{emptyText}</p>;
  }

  return (
    <div className="dashboard-activity-list">
      {items.map((item, index) => {
        const experience = showExperience
          ? formatExperience(item.experienceYears)
          : null;

        return (
          <div
            className="dashboard-activity-item"
            key={item.id ?? `${tone}-${index}`}
          >
            <span className={`dashboard-activity-avatar dashboard-activity-avatar--${tone}`}>
              {initials(item.fullName)}
            </span>
            <div className="flex-grow-1 min-w-0">
              <div className="d-flex align-items-start justify-content-between gap-2">
                <h6 className="mb-1 text-truncate dashboard-activity-name">
                  {item.fullName || "-"}
                </h6>
                <small className="flex-shrink-0 dashboard-activity-date">
                  {formatAddedOn(item.addedOn)}
                </small>
              </div>
              <p className="mb-1 text-truncate dashboard-activity-meta">
                {item.email || "-"}
                {item.phoneNumber ? ` · ${item.phoneNumber}` : ""}
              </p>
              <div className="d-flex flex-wrap gap-2">
                {item.subject ? (
                  <span className="badge bg-light text-body dashboard-activity-chip">
                    {item.subject}
                  </span>
                ) : null}
                {experience ? (
                  <span className="badge bg-light text-body dashboard-activity-chip">
                    {experience}
                  </span>
                ) : null}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export const DashboardRecentActivity = ({
  contacts = [],
  applications = [],
  loading = false,
}) => {
  return (
    <div className="row g-3 mt-1">
      <div className="col-xl-6">
        <div className="card h-100 dashboard-activity-card">
          <div className="card-header d-flex align-items-center justify-content-between">
            <h5 className="card-title mb-0 dashboard-panel-title">
              Recent Contact Requests
            </h5>
            <Link to="/contact-form" className="btn btn-soft-primary btn-sm">
              View All
            </Link>
          </div>
          <div className="card-body">
            {loading ? (
              <Loading />
            ) : (
              <ActivityList
                items={contacts}
                emptyText="No contact requests yet."
                tone="contact"
              />
            )}
          </div>
        </div>
      </div>
      <div className="col-xl-6">
        <div className="card h-100 dashboard-activity-card">
          <div className="card-header d-flex align-items-center justify-content-between">
            <h5 className="card-title mb-0 dashboard-panel-title">
              Recent Career Applications
            </h5>
            <Link to="/career-application" className="btn btn-soft-primary btn-sm">
              View All
            </Link>
          </div>
          <div className="card-body">
            {loading ? (
              <Loading />
            ) : (
              <ActivityList
                items={applications}
                emptyText="No career applications yet."
                tone="career"
                showExperience
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardRecentActivity;
